var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5945 5.04878C44.0729 3.07746 42.5322 1.52384 40.5746 0.995251C37.0264 0.0347499 22.7946 0.021379 22.7946 0.021379C22.7946 0.021379 8.56298 0.00800829 5.01283 0.96184C3.05425 1.48683 1.51063 3.03747 0.985358 5.00781C0.0310023 8.57916 0.024 16.0323 0.024 16.0323C0.024 16.0323 0.0169977 23.4855 0.964641 27.0586C1.48621 29.03 3.02697 30.5189 4.98456 31.0475C8.53291 32.008 22.7646 32.0214 22.7646 32.0214C22.7646 32.0214 36.9962 32.0347 40.5464 31.0809C42.505 30.556 44.0485 29.0699 44.5738 27.0996C45.5282 23.5282 45.5352 16.0751 45.5352 16.0751C45.5352 16.0751 45.5422 8.62192 44.5945 5.04878ZM18.1186 22.8162L18.1314 9.28242L30.0199 16.0607L18.1186 22.8162Z",
    fill: "#010B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileYoutubeIcon);
export default __webpack_public_path__ + "static/media/ProfileYoutubeIcon.aa7ead626a5a5fefecdaba2f2c253105.svg";
export { ForwardRef as ReactComponent };